import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import { WeatherEvent } from 'app/model/SOL49';
import { CheckCircleFilled } from '@ant-design/icons';
import useWindowDimensions from 'app/common/hooks/useWindowDimensions';
import React from 'react';
import TimeUtils from 'app/common/util/TimeUtils';

class WeatherEventColumn extends ManagedColumn<WeatherEvent> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: WeatherEvent) => any,
        extra?: ManagedColumnExtra<WeatherEvent>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export class StandardWeatherEventColumn {
    public static readonly TITLE = new WeatherEventColumn('TITLE', '35em', event => event.title, {
        wordWrapEnabled: true,
    });
    public static readonly TYPE = new WeatherEventColumn('TYPE', '10em', event => event.type, {
        wordWrapEnabled: true,
    });
    public static readonly LAST_UPDATE = new WeatherEventColumn('Last update', '10em', event =>
        TimeUtils.getDayMonthTime(event.lastUpdate),
    );
}

export const WEATHER_EVENT_SELECTED_COLUMN = new WeatherEventColumn(
    '',
    '2em',
    () => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

export const WeatherEventColumns = [
    WEATHER_EVENT_SELECTED_COLUMN,
    StandardWeatherEventColumn.LAST_UPDATE,
    StandardWeatherEventColumn.TYPE,
    StandardWeatherEventColumn.TITLE,
];

class WeatherEventTableBase extends ManagedTable<WeatherEvent> {}

const WeatherEventTable = (props: ManagedTableProps<WeatherEvent>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <WeatherEventTableBase fontSize={fontSize} {...props} />;
};

export default WeatherEventTable;
